function dealWithMultipleCats(cats, catID) {
    let category_array = cats.split(',');
    let category_check = 0;

    for (let i = 0; i < category_array.length; i++) {
        category_array[i] = category_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
        
        if (category_array[i] == catID) {
            category_check = 1;
        }
    }

    return category_check;
}

function egiCurrentlyFunc() {
    let currentlyLink = $('.currently-held-filters li a');

    let catLink = $('.investment-company-categories li a');
    let investmentCompany = $('.investment-company');
    let category_check = 0;

    currentlyLink.on('click', function(e) {
        e.preventDefault();
        currentlyLink.removeClass('active');
        $(this).addClass('active');

        let heldResponse = $(this).data('held');
        let activeCat = 0;

        // check if there is a category selected
        catLink.each(function() {
            if ($(this).hasClass('active')) {
                activeCat = $(this).data('category');
            }
        });
    
        // Check if any industry filters are selected
        let industryFilterList = [];

        // Currently
        if (heldResponse === 'currently') {

            // If category and filters are selected
            if (activeCat > 0 && industryFilterList.length > 0) {
                investmentCompany.each(function() {
                    let filterList = $(this).data('filters');
                    let lengthF = industryFilterList.length;
                    let investmentCompanyHasFilter = false;
                    
                    while(lengthF--) {
                       if (filterList.indexOf(industryFilterList[lengthF])!=-1) {
                           investmentCompanyHasFilter = true;
                       }
                    }

                    category_check = dealWithMultipleCats($(this).data('category'), activeCat);

                    if (category_check && $(this).hasClass('currently-held') && investmentCompanyHasFilter) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            // If category is not selected but filters are selected
            } else if (activeCat == 0 && industryFilterList.length > 0) {
                investmentCompany.each(function() {
                    let filterList = $(this).data('filters');
                    let lengthF = industryFilterList.length;
                    let investmentCompanyHasFilter = false;
                    
                    while(lengthF--) {
                       if (filterList.indexOf(industryFilterList[lengthF])!=-1) {
                           investmentCompanyHasFilter = true;
                       }
                    }

                    if ($(this).hasClass('currently-held') && investmentCompanyHasFilter) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            // If category selected but no filters
            } else if (activeCat > 0 && !industryFilterList.length) {
                investmentCompany.each(function() {
                    category_check = dealWithMultipleCats($(this).data('category'), activeCat);

                    if (category_check && $(this).hasClass('currently-held')) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            } else {
                investmentCompany.each(function() {
                    if ($(this).hasClass('currently-held')) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            }
        // Previously
        } else if (heldResponse === 'previously') {
            // If category and filters are selected
            if (activeCat > 0 && industryFilterList.length > 0) {
                investmentCompany.each(function() {
                    let filterList = $(this).data('filters');
                    let lengthF = industryFilterList.length;
                    let investmentCompanyHasFilter = false;
                    
                    while(lengthF--) {
                       if (filterList.indexOf(industryFilterList[lengthF])!=-1) {
                           investmentCompanyHasFilter = true;
                       }
                    }

                    category_check = dealWithMultipleCats($(this).data('category'), activeCat);

                    if (category_check && !$(this).hasClass('currently-held') && investmentCompanyHasFilter) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            // If category is not selected but filters are selected
            } else if (activeCat == 0 && industryFilterList.length > 0) {
                investmentCompany.each(function() {
                    let filterList = $(this).data('filters');
                    let lengthF = industryFilterList.length;
                    let investmentCompanyHasFilter = false;
                    
                    while(lengthF--) {
                       if (filterList.indexOf(industryFilterList[lengthF])!=-1) {
                           investmentCompanyHasFilter = true;
                       }
                    }

                    if (!$(this).hasClass('currently-held') && investmentCompanyHasFilter) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            // If category selected but no filters
            } else if (activeCat > 0 && !industryFilterList.length) {
                investmentCompany.each(function() {
                    category_check = dealWithMultipleCats($(this).data('category'), activeCat);

                    if (category_check && !$(this).hasClass('currently-held')) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            } else {
                investmentCompany.each(function() {
                    if (!$(this).hasClass('currently-held')) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            }
        // case study
        } else if (heldResponse === 'cs') {
            catLink.removeClass('active')
            activeCat = 0;

            $('.all-investment-categories li a').addClass('active');

            if (activeCat > 0) {
                investmentCompany.each(function() {
                    category_check = dealWithMultipleCats($(this).data('category'), activeCat);

                    if (category_check && $(this).hasClass('has-case-study')) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            } else {
                investmentCompany.each(function() {
                    if ($(this).hasClass('has-case-study')) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            }
        // All
        } else {
            // If category and filters are selected
            if (activeCat > 0 && industryFilterList.length > 0) {
                investmentCompany.each(function() {
                    let filterList = $(this).data('filters');
                    let lengthF = industryFilterList.length;
                    let investmentCompanyHasFilter = false;
                    
                    while(lengthF--) {
                       if (filterList.indexOf(industryFilterList[lengthF])!=-1) {
                           investmentCompanyHasFilter = true;
                       }
                    }

                    category_check = dealWithMultipleCats($(this).data('category'), activeCat);

                    if (category_check && investmentCompanyHasFilter) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            // If category is not selected but filters are selected
            } else if (activeCat == 0 && industryFilterList.length > 0) {
                investmentCompany.each(function() {
                    let filterList = $(this).data('filters');
                    let lengthF = industryFilterList.length;
                    let investmentCompanyHasFilter = false;
                    
                    while(lengthF--) {
                       if (filterList.indexOf(industryFilterList[lengthF])!=-1) {
                           investmentCompanyHasFilter = true;
                       }
                    }

                    if (investmentCompanyHasFilter) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            // If category selected but no filters
            } else if (activeCat > 0 && !industryFilterList.length) {
                investmentCompany.each(function() {
                    category_check = dealWithMultipleCats($(this).data('category'), activeCat);

                    if (category_check) {
                        $(this).removeClass('hide-card').addClass('show-card');
                    } else {
                        $(this).addClass('hide-card').removeClass('show-card');
                    }
                });
            } else {
                investmentCompany.each(function() {
                    $(this).removeClass('hide-card').addClass('show-card');
                });
            }
        }
    });
}

function egiPortfolio() {
    let catLink = $('.investment-company-categories li a');
    let filterLink = $('.investment-industry-filters li a');
    let currentlyLink = $('.currently-held-filters li a');

    catLink.on('click', function(e) {
        e.preventDefault();

        $('.all-investment-categories li a').removeClass('active');

        let catID = $(this).data('category');
        let title = $(this).data('title');
        let description = $(this).data('desc');

        catLink.removeClass('active');
        $(this).addClass('active');

        $(this).closest('.egi-portfolio').find('.egi-portfolio-title').html(title);
        $(this).closest('.egi-portfolio').find('.egi-portfolio-description').html(description);

        // Check if currently is selected
        let heldResponse = 'all';
        currentlyLink.each(function() {
            if ($(this).hasClass('active')) {
                heldResponse = $(this).data('held');
            }
        });

        // Check if any industry filters are selected
        let industryFilterList = [];
        filterLink.each(function() {
            if ($(this).hasClass('active') && $(this).data('filter') !== 'all') {
                industryFilterList.push($(this).data('filter'));
            }
        });

        $('.investment-company').each(function() {
            let category = $(this).data('category');
            let category_array = category.split(',');
            let category_check = 0;

            for (let i = 0; i < category_array.length; i++) {
                category_array[i] = category_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
                
                if (category_array[i] == catID) {
                    category_check = 1;
                }
            }

            if (heldResponse === 'currently') {
                if (category_check && $(this).hasClass('currently-held')) {
                    if (industryFilterList.length > 0) {
                        let filterList = $(this).data('filters');
                        let lengthF = industryFilterList.length;
                        let investmentCompanyHasFilter = false;
                        
                        while(lengthF--) {
                           if (filterList.indexOf(industryFilterList[lengthF])!=-1) {
                               investmentCompanyHasFilter = true;
                           }
                        }
                        
                        if (investmentCompanyHasFilter) {
                            $(this).removeClass('hide-card').addClass('show-card');
                        } else {
                            $(this).addClass('hide-card').removeClass('show-card');
                        }
                    } else {
                        $(this).removeClass('hide-card').addClass('show-card');
                    }
                } else {
                    $(this).addClass('hide-card').removeClass('show-card');
                }
            } else if (heldResponse === 'previously') {
                if (category_check && !$(this).hasClass('currently-held')) {
                    if (industryFilterList.length > 0) {
                        let filterList = $(this).data('filters');
                        let lengthF = industryFilterList.length;
                        let investmentCompanyHasFilter = false;
                        
                        while(lengthF--) {
                           if (filterList.indexOf(industryFilterList[lengthF])!=-1) {
                               investmentCompanyHasFilter = true;
                           }
                        }
                        
                        if (investmentCompanyHasFilter) {
                            $(this).removeClass('hide-card').addClass('show-card');
                        } else {
                            $(this).addClass('hide-card').removeClass('show-card');
                        }
                    } else {
                        $(this).removeClass('hide-card').addClass('show-card');
                    }
                } else {
                    $(this).addClass('hide-card').removeClass('show-card');
                }
            } else if (heldResponse === 'cs') {
                currentlyLink.each(function() {
                    if ($(this).data('held') === 'all') {
                        $(this).addClass('active');
                    } else {
                        $(this).removeClass('active');
                    }
                });
                if (category_check) {
                    if (industryFilterList.length > 0) {
                        let filterList = $(this).data('filters');
                        let lengthF = industryFilterList.length;
                        let investmentCompanyHasFilter = false;
                        
                        while(lengthF--) {
                           if (filterList.indexOf(industryFilterList[lengthF])!=-1) {
                               investmentCompanyHasFilter = true;
                           }
                        }
                        
                        if (investmentCompanyHasFilter) {
                            $(this).removeClass('hide-card').addClass('show-card');
                        } else {
                            $(this).addClass('hide-card').removeClass('show-card');
                        }
                    } else {
                        $(this).removeClass('hide-card').addClass('show-card');
                    }
                } else {
                    $(this).addClass('hide-card').removeClass('show-card');
                }
            } else {
                if (category_check) {
                    if (industryFilterList.length > 0) {
                        let filterList = $(this).data('filters');
                        let lengthF = industryFilterList.length;
                        let investmentCompanyHasFilter = false;
                        
                        while(lengthF--) {
                           if (filterList.indexOf(industryFilterList[lengthF])!=-1) {
                               investmentCompanyHasFilter = true;
                           }
                        }
                        
                        if (investmentCompanyHasFilter) {
                            $(this).removeClass('hide-card').addClass('show-card');
                        } else {
                            $(this).addClass('hide-card').removeClass('show-card');
                        }
                    } else {
                        $(this).removeClass('hide-card').addClass('show-card');
                    }
                } else {
                    $(this).addClass('hide-card').removeClass('show-card');
                }
            }
        });
    });
}

$(document).ready(function() {
    egiPortfolio();
    egiCurrentlyFunc();
});


// WEBPACK FOOTER //
// ./scripts/app.js